<template>
  <thead>
    <tr class="text-start fw-bold fs-7 text-uppercase gs-0 thead-modern">
      <th v-if="checkboxEnabled" style="width:40px; padding-left:16px;">
        <div class="form-check form-check-sm form-check-custom form-check-solid">
          <input class="form-check-input" type="checkbox" v-model="checked" @change="selectAll()" />
        </div>
      </th>
      <th class="th-modern" v-if="noEnabled" style="width:60px;">ลำดับ</th>
      <template v-for="(column, i) in header" :key="i">
        <th
          class="th-modern"
          :class="{ 'text-end': i === header.length - 1, 'sortable': column.sortEnabled }"
          @click="onSort(column.columnLabel, column.sortEnabled)"
          :style="{
            minWidth: column.columnWidth ? `${column.columnWidth}px` : '0',
            width: 'auto',
          }"
        >
          <span class="d-flex align-items-center gap-1">
            {{ column.columnName }}
            <span v-if="column.columnNameOther" class="text-danger fw-normal"> ({{ column.columnNameOther }})</span>
            <span v-if="column.sortEnabled" class="sort-icon ms-1">
              <span v-if="columnLabelAndOrder.label === column.columnLabel" v-html="sortArrow"></span>
              <span v-else class="text-muted opacity-40">⇅</span>
            </span>
          </span>
        </th>
      </template>
    </tr>
  </thead>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import { Sort } from "@/components/kt-datatable/table-partials/models";

export default defineComponent({
  name: "table-head-row",
  props: {
    checkboxEnabledValue: { type: Boolean, required: false, default: false },
    checkboxEnabled: { type: Boolean, required: false, default: false },
    noEnabled: { type: Boolean, required: false, default: false },
    sortLabel: { type: String, required: false, default: null },
    sortOrder: {
      type: String as () => "asc" | "desc",
      required: false,
      default: "asc",
    },
    header: { type: Array, required: true },
  },
  emits: ["on-select", "on-sort"],
  components: {},
  data() {
    return {
      userId: localStorage.getItem("u_id"),
    };
  },
  setup(props, { emit }) {
    const checked = ref<boolean>(false);
    const columnLabelAndOrder = ref<Sort>({
      label: props.sortLabel,
      order: props.sortOrder,
    });

    watch(
      () => props.checkboxEnabledValue,
      (currentValue) => {
        checked.value = currentValue;
      }
    );

    const selectAll = () => {
      emit("on-select", checked.value);
    };

    const onSort = (label: string, sortEnabled: boolean) => {
      if (sortEnabled) {
        if (columnLabelAndOrder.value.label === label) {
          if (columnLabelAndOrder.value.order === "asc") {
            columnLabelAndOrder.value.order = "desc";
          } else {
            if (columnLabelAndOrder.value.order === "desc") {
              columnLabelAndOrder.value.order = "asc";
            }
          }
        } else {
          columnLabelAndOrder.value.order = "asc";
          columnLabelAndOrder.value.label = label;
        }
        emit("on-sort", columnLabelAndOrder.value);
      }
    };

    const sortArrow = computed(() => {
      return columnLabelAndOrder.value.order === "asc"
        ? "&#x2191;"
        : "&#x2193;";
    });

    return {
      onSort,
      selectAll,
      checked,
      sortArrow,
      columnLabelAndOrder,
    };
  },
});
</script>

<style scoped>
.thead-modern {
  background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f9 100%);
  border-bottom: 2px solid #e2e8f0;
}
.th-modern {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #64748b;
  padding: 14px 16px;
  white-space: nowrap;
  border: none;
}
.sortable { cursor: pointer; user-select: none; }
.sortable:hover { color: #323563; background: rgba(50,53,99,0.05); }
.sort-icon { font-size: 11px; }
</style>
